import PropTypes from "prop-types";
import { Form } from "@circle-react-uikit/Form";
import { Advanced } from "./Advanced";
import { BasicInfo } from "./BasicInfo";

export const NewSpaceGroupForm = ({ onSubmit, formId, prefillData }) => (
  <Form
    id={formId}
    onSubmit={onSubmit}
    defaultValues={prefillData || {}}
    className="h-full"
  >
    <div className="flex-1">
      <BasicInfo />
      <Advanced />
    </div>
  </Form>
);

NewSpaceGroupForm.propTypes = {
  onSubmit: PropTypes.func,
  formId: PropTypes.string,
  prefillData: PropTypes.object,
};
